/**
 * Newsletter API
 *
 * Endpoints:
 *   POST api/v1/newsletter/subscribe - subscribe
 */
import { apiClientPostRequest } from '../lib/backendRequest';

const newsletterApi = () => ({
  /**
   * Subscribe an email to the Press Sheet newsletter. No account needed.
   *
   * @param {string} email
   * @param {string} [honeypot] Value of the hidden bot trap field, empty for people.
   * @returns {{ data: true } | { invalid: string } | { error: string }} `invalid` when the
   *   backend rejects the email, `error` for anything else.
   */
  async subscribe(email, honeypot = '') {
    try {
      await apiClientPostRequest('api/v1/newsletter/subscribe', {
        email,
        website: honeypot || undefined,
      });

      return { data: true };
    } catch (e) {
      if (e.code === 400) {
        return { invalid: 'Please enter a valid email address.' };
      }
      return { error: 'Something went wrong. Please try again.' };
    }
  },
});

export default newsletterApi;
